import React from 'react';

export const Profile: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="8 8 8 8" {...props}>
    <path
      d="M12.02 15.3H8.988c0-2.187 1.92-2.186 2.347-2.758l.049-.261a2.09 2.09 0 01-1.022-1.888 1.873 1.873 0 011.637-2.041 1.873 1.873 0 011.638 2.041 2.1 2.1 0 01-1.006 1.884l.056.3c.468.544 2.324.58 2.324 2.729z"
      fill="currentColor"
    />
  </svg>
);
